import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.scss';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="container">
        <h1 className="privacy-policy__title">Privacy Policy</h1>
        
        <div className="privacy-policy__intro">
          <p>
            At Skil.AI, we take your privacy seriously. This Privacy Policy explains how we collect, use, 
            disclose, and safeguard your information when you use our AI-powered chatbot services.
          </p>
        </div>

        <div className="privacy-policy__section">
          <h2>Information Collection</h2>
          <p>We collect information that you provide directly to our chatbot, including:</p>
          <ul>
            <li>Personal information (name, email address, phone number)</li>
            <li>Chat logs and message content</li>
            <li>Timestamps and interaction data</li>
          </ul>
        </div>

        <div className="privacy-policy__section">
          <h2>Use of Information</h2>
          <p>We use the collected information to:</p>
          <ul className="checkmark-list">
            <li>Provide and improve our chatbot services</li>
            <li>Respond to your inquiries and provide support</li>
            <li>Send you promotional and marketing communications</li>
            <li>Share information with third-party service providers (we do not sell, rent, or trade your information)</li>
          </ul>
        </div>

        <div className="privacy-policy__section">
          <h2>Cookies and Other Tracking Technologies</h2>
          <p>
            We use cookies and similar tracking technologies to track activity on our service and hold certain 
            information. These technologies are used to gather information about how you interact with our 
            chatbot and to improve your experience.
          </p>
        </div>

        <div className="privacy-policy__section">
          <h2>Data Retention</h2>
          <p>
            We will retain your information for as long as necessary to provide our services and as required 
            by applicable laws and regulations.
          </p>
        </div>

        <div className="privacy-policy__section">
          <h2>Content Disclaimer</h2>
          <p>
            Our chatbot may generate content that could be offensive, inappropriate, or misleading. We do not 
            guarantee the accuracy, completeness, or reliability of any content generated by our chatbot.
          </p>
          <p>
            We are not liable for any damages or losses resulting from the use of our chatbot's generated 
            content. If you encounter any inappropriate content, please report it to{' '}
            <a href="mailto:info@skil.ai">info@skil.ai</a>.
          </p>
        </div>

        <div className="privacy-policy__section">
          <h2>Security</h2>
          <p>
            We implement appropriate security measures to protect your information, including SSL encryption. 
            However, no method of transmission over the Internet is 100% secure.
          </p>
        </div>

        <div className="privacy-policy__section">
          <h2>Changes to Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting 
            the new Privacy Policy on this page.
          </p>
        </div>

        <div className="privacy-policy__section">
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at{' '}
            <a href="mailto:info@skil.ai">info@skil.ai</a>.
          </p>
        </div>
      </div>

      <div className="privacy-policy__cta">
        <div className="container">
          <h3>Get in touch with us</h3>
          <Link to="/contact" className="button button--primary">Request Demo</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 